module.exports = "/_next/static/images/missouri-35f1c5fa30711c5e0cfcc77bd03770f1.svg";